<template>
    <div>
        <header>
            <el-form :inline="true" class="demo-form-inline" label-width="100px" size="small">
                <el-form-item label="费用方案查询">
                    <el-input clearable v-model="condition" placeholder="请输入关键字"
                        style="width: 100%;"></el-input>
                </el-form-item>
                <el-form-item >
                    <el-button type="primary" @click="getData" style="flex-wrap: nowrap; ">查询</el-button>
                    <el-button v-if="rolePermission === '领导'" type="success" @click="update">增加</el-button>
                </el-form-item>
            </el-form>
        </header>
        <main>
                <el-table :data="list" height="calc(100vh - 136px)" :cell-style="rowStyle" id="tableId" ref="tableId"
                    min-width="30px" style="font-size: 14px;  margin-top: 0px;" size="mini">
                    <el-table-column label="序号" type="index" width="60" align="center">
                    </el-table-column>
                    <el-table-column label="模板名称" width="auto" align="center">
                        <template slot-scope="scope">
                            <!-- <i class="iconfont icon-bianmubianma"></i> -->
                            <el-link  type="primary" style="font-size: 14px;" @click="handleClick(scope.row)" >{{ scope.row.templateName }}</el-link>
                            <!-- <span v-else type="primary">{{ scope.row.templateName }}</span> -->
                            <!-- <span @click="handleClick(scope.row)" :class="{ hoverStyle: true }"
                                style="margin-left: 10px; cursor: pointer">{{ scope.row.templateName }}</span> -->
                        </template>
                    </el-table-column>
                    <el-table-column label="结算对象" width="auto" align="center">
                        <template slot-scope="scope">
                            <!-- <i class="iconfont icon-bianmubianma"></i> -->
                            <span style="margin-left: 10px">{{ scope.row.custName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="创建人" width="auto" align="center">
                        <template slot-scope="scope">
                            <!-- <i class="iconfont icon-bianmubianma"></i> -->
                            <span style="margin-left: 10px">{{ scope.row.createMan }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="创建时间" width="auto" align="center">
                        <template slot-scope="scope">
                            <!-- <i class="iconfont icon-bianmubianma"></i> -->
                            <span style="margin-left: 10px">{{ scope.row.createTime }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="模板备注" width="auto" align="center">
                        <template slot-scope="scope">
                            <!-- <i class="iconfont icon-bianmubianma"></i> -->
                            <span style="margin-left: 10px">{{ scope.row.tempNote }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column  label="操作" width="auto" align="center" v-if="rolePermission === '领导'">
                        <template slot-scope="scope">
                            <!-- <el-button round size="small" icon="el-icon-edit" type="warning"
                                @click="amendRow(scope.row)">修改</el-button> -->
                            <el-button plain size="small" icon="el-icon-delete" type="danger"
                                @click="deleteRow(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            <changeFeeScheme ref="changeFeeScheme" :rowData="selectedRow"></changeFeeScheme>
            <!-- 添加字典类型弹框 -->
            <!-- <div>
                <el-dialog title="添加字典类型" :show-close="false" :close-on-click-modal="false" fullScreen
                    :visible.sync="dialogFormVisible">
                    <el-form>
                        <el-form-item label="字典类型">
                            <el-input v-model.trim="type" autocomplete="off"></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="cancel">取 消</el-button>
                        <el-button type="primary" @click="confirmChange">确 定</el-button>
                    </div>
                </el-dialog>
            </div> -->
        </main>
    </div>
</template>

<script>
import req from '@/utils/index.js'
import url from '@/config/url2.js'
import changeFeeScheme from "@/view/changeFeeScheme.vue";
export default {
    name: 'expenseTemplates',
    components: { changeFeeScheme, },
    data() {
        return {
            rolePermission:localStorage.getItem('role'),
            condition: '',
            list: [],
            // dialogFormVisible: false,
            // type: '',
            selectedRow: null, //传入子组件当前行数据

        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        rowStyle() {
            return "text-align:center";
        },
        deleteRow(row) {
            this.$confirm('是否删除该费用方案', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let URL = `${url.deleteTemplate}/${row.id}`;
                req.delete(URL).then(res => {
                    if (res.data.code === 200) {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.getData();
                    } else {
                        this.$message({
                            type: 'error',
                            message:res.data.message
                        });
                    }
                })


            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });

        },
        // 查询任务列表
        getData() {
            // this.currentPage = page;
            let URL = `${url.getTemplateByName}?name=${this.condition}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.list = res.data.data;
                }
            })
        },
        update() {
            this.$refs.changeFeeScheme.dialogCartonVisible = true;
        },
        // confirmChange() {
        //     let URL = `${url.addDicType}/?name=${this.type}`;
        //     req.post(URL).then(res => {
        //         if (res.data.code === 200) {
        //             this.$message({
        //                 type: 'success',
        //                 message: '新增成功'
        //             })
        //             this.getData();
        //             this.type = '';//情空
        //             this.dialogFormVisible = false;
        //         } else {
        //             this.$message({
        //                 type: 'error',
        //                 message: res.data.message
        //             })
        //         }
        //     })
        // },
        // cancel() {
        //     this.dialogFormVisible = false;
        // },
        handleClick(row) {
            this.selectedRow = row;
            this.$nextTick(() => {
                this.$refs.changeFeeScheme.amendDetail();
            })
            this.$refs.changeFeeScheme.dialogCartonVisible = true;
        }
    },

}
</script>

<style lang="css" scoped>
.hoverStyle:hover {
    color: blue;
    /* 设置悬停时的字体颜色 */
    text-decoration: underline;
    /* 添加下划线 */
}
::v-deep .el-form-item {
    margin-bottom: 10px;
}
</style>